/**
 * evolution-finance.js
 * --------------------
 * Finds all [data-evo-finance] elements on the page and fetches
 * monthly payment figures from the Evolution Funding API via the
 * server-side proxy, then injects them into the DOM.
 *
 * Add to your theme.liquid just before </body>:
 *   {{ 'evolution-finance.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  /**
   * Format a number as £X,XXX.XX per month
   */
  function formatCurrency(value) {
    return '£' + parseFloat(value).toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /**
   * Fetch a single finance quote for one product element.
   * Falls back gracefully — if anything goes wrong the element is hidden.
   */
function fetchQuote(el) {
    var proxyUrl = el.getAttribute('data-proxy-url');
    var price    = el.getAttribute('data-price');
    var vrm      = el.getAttribute('data-vrm');
    var miles    = el.getAttribute('data-miles') || '0';
    var amountEl = el.querySelector('.evo-finance-price__amount');

    var payload = {
      cprice:        price,
      vrm:           vrm,
      current_miles: miles
    };

    fetch(proxyUrl, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function (data) {
      if (data && data.regular) {
        amountEl.textContent = formatCurrency(data.regular);
        el.classList.add('evo-finance-price--loaded');
      } else {
        el.style.display = 'none';
      }
    })
    .catch(function () {
      // Silently hide if the quote cannot be obtained
      el.style.display = 'none';
    });
  }

  /**
   * Initialise — find all finance widgets and kick off fetches.
   * Uses IntersectionObserver where available so off-screen products
   * are only fetched when they scroll into view (saves API calls on
   * collection pages with many listings).
   */
  function init() {
    var elements = document.querySelectorAll('[data-evo-finance]');
    if (!elements.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            obs.unobserve(entry.target);
            fetchQuote(entry.target);
          }
        });
      }, { rootMargin: '200px' });

      elements.forEach(function (el) { observer.observe(el); });
    } else {
      // Fallback: fetch all immediately
      elements.forEach(fetchQuote);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
